import React from "react";
import { Badge, Card, Col, Row } from "react-bootstrap";
import CountUp from "react-countup";
import EnergoTooltip from "./EnergoTooltip";
import { useAuthState } from "../../context/AuthContext";
import { useTooltips } from "../../context/TooltipsContext";

/**
 * DashCard component
 * 
 * display cards with icon, number and description
 * 
 * @param {props} schema string color schema of card
 * @param {props} disabled boolean if passed disable the card
 * @param {props} path string url path
 * @param {props} icon html-element icon 
 * @param {props} counter integer if passed displays number in upper right corner
 * @param {props} badge string if passed shows badge
 * @param {props} text string text desciprtion under icon
 * @param {props} pulse bool optional parameter to pulse entire card
 * @param {props} linkText string optional parameter to change link text
 * 
 * @returns gui Card
 */
const DashCard = ({schema, disabled, path, icon, counter, badge, text, pulse=false, linkText="ansehen"}) => {

    const { tooltipsTrigger } = useTooltips();


    // GUI
    return (
        <a className="link-energo" href={disabled? null : path}>
        <Card 

            style={{borderRadius: "20px", height: "100%", border: 0}}
            className={`disabled-select ${disabled ? 'card-disabled shadow-lg' : 'shadow-lg'} ${pulse? "animate__animated animate__pulse animate__slow animate__infinite":""}`}
        >
            <Card.Body>
                <Row>
                    <Col xs="6" style={{position: "relative", top: "-40px"}}>
                        {icon}
                    </Col>
                    <Col xs="6" className="text-end">
                        {counter? 
                            <h1 className={`text-${schema}`}>
                                <CountUp end={counter} />
                            </h1>
                            :
                            null
                        }
                        {badge?
                            <Badge className="pulse" bg={schema}>{badge}</Badge>
                        :
                            null
                        }
                    </Col>
                </Row>
                <Row style={{position: "relative", top: "-20px"}}>
                    <Col>
                        <small>{text}</small>
                    </Col>
                </Row>
                <Row>
                    <Col xs="1" >
                        {
                            text === "Verwaltete Gebäude" ?
                                <EnergoTooltip tKey="1001" position="right" /> :
                        
                            text === "Aktive Energielieferverträge" ?
                                <EnergoTooltip tKey="1002" position="right" /> :
                            
                            text === "Downloadbereich" ?
                                <EnergoTooltip tKey="1003" position="right" /> :

                            text === "Ungelesene Benachrichtigungen" ?
                                <EnergoTooltip tKey="1004" position="right" /> :

                            text === "Offene Tickets" ?
                                <EnergoTooltip tKey="1005" position="right" /> :

                            text === "Neue WEG/MEG" ?
                                <EnergoTooltip tKey="1006" position="right" />:
                            text === "Meine Anlagen" ?
                                <EnergoTooltip tKey="1007" position="right" /> :

                            null
                        }
                    </Col>
                    <Col xs={tooltipsTrigger? "11":"12"} className="text-end" hidden={disabled}>
                        <b className="text-energo">{linkText}</b>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
        </a>
    )
} 
export default DashCard;